/**
 * `CHARGE_INVOICES_ACTIONS` (AF-4118): quais ações o modal de faturas do título oferece, e se a
 * amortização da operação aparece também no step 3 da Identificação de Pagamentos.
 *
 * Fica fora do billingApi pelo mesmo motivo do invoicePaymentAction: as telas mockam o billingApi
 * inteiro, e a regra mora aqui para os testes delas a rodarem de verdade.
 */
import { LiquidationMode, PAYMENT_MODES_BY_SCENARIO } from '../constants/liquidationModes';

export interface ChargeInvoicesActions {
    NEW_INVOICE: boolean;
    OPERATION_WATERFALL: boolean;
    CANCEL: boolean;
    UNCOLLECT: boolean;
}

/** Espelho do seed (changelog_055 do billing): vale quando a leitura falha. */
export const CHARGE_INVOICES_ACTIONS_FALLBACK: ChargeInvoicesActions = {
    NEW_INVOICE: true,
    OPERATION_WATERFALL: false,
    CANCEL: false,
    UNCOLLECT: true,
};

/** Os modos que a natureza permite, sem a amortização quando a propriedade a desliga. */
export const liquidationModesFor = (
    scenario: string | null | undefined, actions: ChargeInvoicesActions,
): LiquidationMode[] => {
    const modes = PAYMENT_MODES_BY_SCENARIO[scenario || 'GUARANTEE'] || ['TOTAL'];
    return actions.OPERATION_WATERFALL ? modes : modes.filter(mode => mode !== 'OPERATION_WATERFALL');
};

/**
 * Os modos de UMA linha: os permitidos, mais o já escolhido quando só a propriedade o tirou.
 *
 * É o caso da marcação gravada como amortização antes de `OPERATION_WATERFALL` ser desligado: ao
 * reabri-la, rebaixar para "Liquidar" mudaria o efeito do dinheiro sem ninguém escolher (review da
 * backoffice#1267). A opção fica só enquanto estiver escolhida; a natureza continua mandando.
 */
export const liquidationModesKeeping = (
    scenario: string | null | undefined, actions: ChargeInvoicesActions, current: LiquidationMode,
): LiquidationMode[] => {
    const allowed = liquidationModesFor(scenario, actions);
    const byNature = liquidationModesFor(scenario, { ...actions, OPERATION_WATERFALL: true });
    return !allowed.includes(current) && byNature.includes(current) ? [...allowed, current] : allowed;
};

